import { IBaseComponent } from "../models/formFields.interfaces";
import { AbstractFormComponent } from "./AbstractFormComponent";

export class NonFieldErrors extends AbstractFormComponent<
    IBaseComponent,
    Record<string, never>
> {}
